/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  UserFlagsModeratorControllerDeleteMutationResponse,
  UserFlagsModeratorControllerDeletePathParams,
  UserFlagsModeratorControllerDelete401,
} from '../../types/UserFlagsModeratorControllerDelete.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { userFlagsModeratorDelete } from '../../methods/userFlagsModeratorDelete.ts';
import { useMutation } from '@tanstack/react-query';

export const userFlagsModeratorDeleteMutationKey = () => [{ url: '/api/moderator/user-flags/:id' }] as const;

export type UserFlagsModeratorDeleteMutationKey = ReturnType<typeof userFlagsModeratorDeleteMutationKey>;

/**
 * {@link /api/moderator/user-flags/:id}
 */
export function useUserFlagsModeratorDelete<TContext>(
  options: {
    mutation?: UseMutationOptions<
      UserFlagsModeratorControllerDeleteMutationResponse,
      ResponseErrorConfig<UserFlagsModeratorControllerDelete401>,
      { id: UserFlagsModeratorControllerDeletePathParams['id'] },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? userFlagsModeratorDeleteMutationKey();

  return useMutation<
    UserFlagsModeratorControllerDeleteMutationResponse,
    ResponseErrorConfig<UserFlagsModeratorControllerDelete401>,
    { id: UserFlagsModeratorControllerDeletePathParams['id'] },
    TContext
  >(
    {
      mutationFn: async ({ id }) => {
        return userFlagsModeratorDelete(id, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
